import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSetAtom } from "jotai";
import { Icon } from "assets/icons";

import { Divider } from "components/Spacing";
import { Text } from "components/Text";
import { Accordion } from "components/Accordion";
import { useModal, ConfirmationModal } from "components/Modal";

import { mainLogo } from "utils/assets";

import { tokenAtom } from "atoms/accountAtom";

import { MENU_CONFIG } from "./menuConfig";
import styles from "./styles.module.scss";

const MenuItem = ({ icon, name, onClick, isActive }) => (
  <div
    className={`${styles.menuItem} hoverBg ${isActive ? styles.menuItemActive : ""}`}
    onClick={onClick}
  >
    <span className={styles.menuItemIcon}>
      {!!icon && <Icon size={20} type={icon} />}
    </span>
    <Text size={14} className={styles.menuItemText}>
      {name}
    </Text>
  </div>
);

const Menu = () => {
  const [collapse, setCollapse] = useState({});

  const toggle = (name) =>
    setCollapse((prev) => ({ ...prev, [name]: !prev[name] }));

  return (
    <div className={styles.menu}>
      {MENU_CONFIG.map(({ name, ...menuItem }) => {
        if (menuItem.children) {
          return (
            <Accordion
              withIcon
              key={name}
              collapsed={!!collapse[name]}
              parent={
                <MenuItem
                  icon={menuItem.icon}
                  name={name}
                  onClick={() => toggle(name)}
                />
              }
            >
              {menuItem.children.map((child) => (
                <NavLink
                  key={child.path}
                  to={child.path}
                  className={({ isActive }) =>
                    isActive ? styles.linkActive : undefined
                  }
                >
                  <MenuItem name={child.name} />
                </NavLink>
              ))}
            </Accordion>
          );
        }
        return (
          <NavLink
            key={name}
            to={menuItem.path}
            className={({ isActive }) =>
              isActive ? styles.linkActive : undefined
            }
            end
          >
            <MenuItem icon={menuItem.icon} name={name} />
          </NavLink>
        );
      })}
    </div>
  );
};

const BottomMenu = () => {
  const setToken = useSetAtom(tokenAtom);
  const { openModal, closeModal } = useModal();

  const onLogoutClick = () => {
    openModal(
      <ConfirmationModal
        title="Вы уверены, что хотите выйти?"
        confirmText="Выйти"
        danger={false}
        onConfirm={() => {
          localStorage.removeItem("token");
          setToken("");
          closeModal();
        }}
        onClose={closeModal}
      />
    );
  };

  return (
    <div className={styles.bottomMenu}>
      <NavLink
        to="/help"
        className={({ isActive }) =>
          isActive ? styles.linkActive : undefined
        }
      >
        <MenuItem name="Помощь" icon="help" />
      </NavLink>
      <NavLink
        to="/settings"
        className={({ isActive }) =>
          isActive ? styles.linkActive : undefined
        }
      >
        <MenuItem name="Настройки" icon="settings" />
      </NavLink>
      <MenuItem name="Выйти" icon="logout" onClick={onLogoutClick} />
    </div>
  );
};

export const LeftNavBar = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.leftNavBar}>
      <div className={styles.logoWrapper}>
        <img
          src={mainLogo}
          alt="Florapoint"
          className={`${styles.logo} clickable`}
          onClick={() => navigate("/")}
        />
      </div>
      <Divider />
      <Menu />
      <Divider />
      <BottomMenu />
    </div>
  );
};
